export default __webpack_public_path__ + "media/images/borders/green-border-90f188baa378e2719a4a17e32e72e29a.svg";